"use client";

import { api } from "~/trpc/react";
import { Skeleton } from "../ui/skeleton";
import { Clock4 } from "lucide-react";
import { IconTextRow } from "~/components/ui/icon-text-row";

export default function UsuallyRespondsWithin(props: {
  therapistId: string;
  therapistUserId: string;
  therapistName: string | null;
  variant?: "default" | "sidebar";
}) {
  const usuallyRespondsWithin = api.therapistRouter.getResponseTime.useQuery({
    therapistId: props.therapistId,
    therapistUserId: props.therapistUserId,
  });

  if (usuallyRespondsWithin.isLoading) {
    return (
      <Skeleton
        className={
          props.variant === "sidebar"
            ? "h-5 w-full rounded-md"
            : "h-[16px] w-full rounded-md md:w-[336px]"
        }
      />
    );
  }

  if (!usuallyRespondsWithin.data) {
    return null;
  }

  const firstName = props.therapistName?.trim().split(/\s+/)[0];
  const responseText = firstName
    ? usuallyRespondsWithin.data.replace(/^Obično/, `${firstName} obično`)
    : usuallyRespondsWithin.data;

  if (props.variant === "sidebar") {
    return (
      <IconTextRow icon={Clock4}>
        <span className="text-muted-foreground text-sm">{responseText}</span>
      </IconTextRow>
    );
  }

  return (
    <div className="text-muted-foreground flex flex-col items-center space-y-1 space-x-1 md:flex-row md:space-y-0">
      <div className="flex items-center text-xs">
        <Clock4 className="mr-2 h-4 w-4" />
        <span>{responseText}</span>
      </div>
    </div>
  );
}
